import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { forget, peek } from '@utils/returnTo';

interface IReturnToRedirectProps {
  fallback: string;
}

// Reads without clearing during render and clears in an effect: StrictMode renders twice, so a
// destructive read in render would hand the second pass the fallback.
const ReturnToRedirect: React.FC<IReturnToRedirectProps> = ({ fallback }) => {
  useEffect(() => {
    forget();
  }, []);

  return <Navigate to={peek(fallback)} replace />;
};

export default ReturnToRedirect;
